export class Category {
    public uuid: string;
    public name: string;
    public description: string;

    public active: boolean;

    constructor() {}
}
